import { Prisma, Place as PrismaPlace } from "@prisma/client";

export const structuresPlace = [
  "J",
  "L",
  "M",
  "N",
  "O",
  "P",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "OA",
  "GA",
  "PA",
  "CTS",
  "EF",
] as const;
export type StructurePlace = (typeof structuresPlace)[number];

export const areaTypes = ["custom", "room", "hall", "amphitheater"] as const;
export type AreaType = (typeof areaTypes)[number];

export function getAreaTypeTranslation(type: AreaType) {
  switch (type) {
    case "custom":
      return "Autre";
    case "room":
      return "Salle";
    case "hall":
      return "Hall";
    case "amphitheater":
      return "Amphithéâtre";
  }
}

export const placesTypes = [
  "castle",
  "museum",
  "viewpoint",
  "park",
  "monument",
  "other",
] as const;
export type PlaceType1 = (typeof placesTypes)[number];

export function getPlaceTypeTranslation(type: PlaceType1) {
  switch (type) {
    case "castle":
      return "Château";
    case "museum":
      return "Musée";
    case "viewpoint":
      return "Point de vue";
    case "park":
      return "Parc";
    case "monument":
      return "Monument";
    case "other":
      return "Autre";
  }
}

export type PlaceFilters = {
  searchText?: string;
};

export type FilterPlaceType = {
  name?: string;
};

export const placeTypeValues = Prisma.validator<Prisma.PlaceDefaultArgs>()({
  include: {
    areas: {
      orderBy: {
        name: "asc",
      },
    },
    placeEntrances: {
      include: {
        address: true,
      },
      orderBy: {
        name: "asc",
      },
    },
    image: true,
  },
});

export type PlaceType = Prisma.PlaceGetPayload<typeof placeTypeValues>;

export const placeWithUserTypeValues =
  Prisma.validator<Prisma.PlaceDefaultArgs>()({
    include: {
      ...placeTypeValues.include,
      user: true,
    },
  });

export type PlaceWithUserType = Prisma.PlaceGetPayload<
  typeof placeWithUserTypeValues
>;

export const placeTypeTypeValues = [
  "castle",
  "museum",
  "viewpoint",
  "park",
  "monument",
  "other",
] as const;

export type PlaceTypeType = (typeof placeTypeTypeValues)[number];

export type PlaceItemType = PrismaPlace;
